<template>
  <div
    class="container"
    :class="{ 'full-screen': fullScreen }"
    :style="{ height: isCollapse ? 'unset' : height }"
  >
    <div class="label-content">
      <slot name="label">
        <span class="rect"></span>
        <label> {{ label }}</label>
      </slot>
      <span class="line"></span>
      <slot name="btn"></slot>
      <span class="arrow">
        <i
          v-show="hasCollapse"
          class="el-icon"
          :class="{
            'el-icon-caret-bottom': !isCollapse,
            'el-icon-caret-top': isCollapse
          }"
          style="cursor: pointer"
          @click="isCollapse = !isCollapse"
        ></i>
      </span>
      <el-button
        v-if="showFullScreen"
        class="full-screen-btn"
        @click="handleFullScreen"
        type="text"
        :icon="fullScreen ? 'el-icon-close' : 'el-icon-full-screen'"
      ></el-button>
    </div>
    <div
      class="content"
      v-show="!isCollapse"
      :style="{
        paddingTop: topPadding,
        paddingBottom: bottomPadding,
        height: `calc(100% - 22px - ${topPadding} - ${bottomPadding})`
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelContent',
  props: {
    label: {
      type: String,
      default: ''
    },
    // 是否可折叠
    hasCollapse: {
      type: Boolean,
      default: false
    },
    showFullScreen: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: ''
    },
    topPadding: {
      type: String,
      default: '10px'
    },
    bottomPadding: {
      type: String,
      default: '10px'
    }
  },
  data() {
    return {
      // 页面数据
      isCollapse: false,
      fullScreen: false
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    handleFullScreen() {
      this.fullScreen = !this.fullScreen
    }
  }
}
</script>

<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  position: relative;
  > div {
    width: 100%;
  }
  &.full-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% !important;
    z-index: 1888;
    background: #fff;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    > .content {
      flex: 1;
      overflow: hidden;
      ::v-deep .tab-btn {
        height: 100% !important;
        overflow: auto;
      }
      ::v-deep .left-right-box {
        height: 100% !important;
      }
    }
  }

  .full-screen-btn {
    position: absolute;
    color: red;
    right: 37px;
    z-index: 88;
    top: 3px;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
  }
}
.label-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  .rect {
    display: inline-block;
    width: 6px;
    height: 14px;
    background-color: #006ffa;
    margin-right: 8px;
  }
  label {
    color: #000;
    font-weight: 600;
  }
  .line {
    margin-left: 40px;
    flex: 1;
    height: 1px;
    background-color: #3fa5dc;
  }
  .arrow {
    display: flex;
    width: 14px;
    margin-left: 30px;
    margin-right: 20px;
    font-size: 28px;
    color: #000;
    i {
      margin-top: -6px;
    }
  }
}
.content {
  width: 100%;
  box-sizing: content-box;
}
</style>
